<template>
  <div class="create-subject">
    <button class="width-100"
            :class="[{'do-bttn': isInDCalendar}, {'bttn': !isInDCalendar}]"
            v-if="!isHideCreateButton"
            @click="isSubjectModal = true"><span
      class="icon-clipboard2"></span>
      {{ $t('vue2.create_subject.create_subject') }}
    </button>
    <CreateSubjectForm
      v-if="isSubjectModal"
      :showModal="isSubjectModal"
      :initCalendarId="calendarId"
      :editSubject="editSubject"
      :editSubjectId="editSubjectId"
      :isInDCalendar="isInDCalendar"
      @close="closeModal"
      @setTheEditSubject="setTheEditSubject"
      @createSubject="createNewSubject"
      @updateSubject="updateSubject"
      @deleteSubject="deleteSubject">
    </CreateSubjectForm>
  </div>
</template>

<script>
import CreateSubjectForm from './CreateSubjectForm'
import moment from 'moment'

export default {
  components: {CreateSubjectForm},
  props: {
    calendarId: {
      default: null
    },
    isHideCreateButton: {
      type: Boolean,
      default: false
    },
    isInDCalendar: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isSubjectModal: false,
      editSubject: null,
      editSubjectId: null,
      calCurrentDate: moment()
    }
  },
  computed: {
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    activeCalendar () {
      return this.allCalendarsInHash[this.calendarId]
    },
    schoolYearIdToCreateSubject () {
      return this.activeCalendar && this.activeCalendar.school_year_id ? this.activeCalendar.school_year_id : this.activeSchoolYear.id
    },
    theEditSubject () {
      return this.$store.state.calendar.editSubject
    }
  },
  watch: {
    theEditSubject () {
      if (this.theEditSubject) {
        this.setEditSubject(this.theEditSubject)
      }
    }
  },
  methods: {
    createNewSubject (newSubject) {
      newSubject['schoolYearId'] = this.schoolYearIdToCreateSubject
      newSubject['calCurrentdate'] = this.calCurrentDate
      if (this.isInDCalendar) {
        this.$store.dispatch('createCalendarSubject', newSubject)
      } else {
        this.$store.dispatch('createSubject', newSubject)
      }
      this.closeModal()
    },
    setEditSubject (editSubject) {
      this.editSubject = Object.assign({}, editSubject)
      if (this.isInDCalendar && this.editSubject.cals) {
        this.editSubject.calendar_ids = this.editSubject.cals.map(cal => cal.id)
      }
      this.isSubjectModal = true
    },
    updateSubject (updatedSubject) {
      if (this.isInDCalendar) {
        this.$store.dispatch('updateCalendarSubject', updatedSubject)
      } else {
        this.$store.dispatch('updateSubject', updatedSubject)
      }
      this.closeModal()
    },
    deleteSubject (editSubject) {
      if (this.isInDCalendar) {
        this.$store.dispatch('deleteCalendarSubject', editSubject)
      } else {
        let deletedSubject = {
          id: editSubject.id,
          school_id: editSubject.school_id,
          school_year_id: this.activeSchoolYear.id
        }
        deletedSubject['schoolYearId'] = this.activeSchoolYear.id
        this.$store.dispatch('deleteSubject', deletedSubject)
      }
      this.closeModal()
    },
    closeModal () {
      this.editSubject = null
      this.editSubjectId = null
      this.$store.commit('setEditSubject', null)
      this.isSubjectModal = false
    },
    setTheEditSubject (theEditSubject) {
      this.editSubject = theEditSubject
    }
  },
  mounted () {
    // Listen for the ROR FullCalendar-event
    window.addEventListener('fullcal_view_or_date_changed', e => {
      this.calCurrentDate = e.detail
    }, false)
    // Listen for the ROR FullCalendar-event
    window.addEventListener('vue::editSubject', e => {
      this.editSubjectId = e.detail
      this.isSubjectModal = true
      // this.calCurrentDate = e.detail
    }, false)
  }
}
</script>

<style scoped>
.create-subject {
  margin-bottom: 1rem;
}
</style>



// WEBPACK FOOTER //
// CreateSubject.vue?5bdab3c9